import { render } from "./centerRotate.vue?vue&type=template&id=b5bac3a8&scoped=true"
import script from "./centerRotate.vue?vue&type=script&lang=js"
export * from "./centerRotate.vue?vue&type=script&lang=js"

import "./centerRotate.vue?vue&type=style&index=0&id=b5bac3a8&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5bac3a8"]])

export default __exports__